var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cv-file-uploader',{staticClass:"ff-input",class:{
    'is-secondary': _vm.type === 2,
    'is-file': _vm.accept === '*',
    'is-menu': _vm.menu,
  },attrs:{"accept":_vm.accept,"drop-target-label":_vm.text},on:{"input":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }